import { normalizePlateSearch } from './plateSearch';
import { getTicketImages } from './ticketImages';

const cleanString = value => String(value || '').trim();

const parseTimestamp = value => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }

  const stringValue = cleanString(value);

  if (!stringValue) {
    return 0;
  }

  const candidates = [
    stringValue,
    stringValue.replace(' ', 'T'),
    stringValue.replace(/\//g, '-'),
    stringValue.replace(/\//g, '-').replace(' ', 'T'),
  ];

  for (const candidate of candidates) {
    const parsed = Date.parse(candidate);

    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }

  return 0;
};

export const getTicketCreatedAt = ticket => {
  const explicitCreatedAt = parseTimestamp(ticket?.createdAt);

  if (explicitCreatedAt) {
    return explicitCreatedAt;
  }

  const datetimeCreatedAt = parseTimestamp(ticket?.datetime);

  if (datetimeCreatedAt) {
    return datetimeCreatedAt;
  }

  return parseTimestamp(`${cleanString(ticket?.date)} ${cleanString(ticket?.time)}`);
};

export const getTicketId = (ticket, fallbackId = '') => cleanString(
  ticket?.ticketid
  || ticket?.ticketId
  || ticket?.ticketNumber
  || fallbackId
);

export const buildPlateIndexEntry = (ticket, fallbackId = '') => {
  const ticketId = getTicketId(ticket, fallbackId);
  const plate = cleanString(ticket?.carplate || ticket?.plate);
  const plateNormalized = normalizePlateSearch(ticket?.plateNormalized || plate);
  const carbrand = cleanString(ticket?.carbrand || ticket?.make);
  const carmodel = cleanString(ticket?.carmodel || ticket?.model);
  const contract = cleanString(ticket?.contract);
  const address = cleanString(ticket?.address || ticket?.location);
  const images = getTicketImages(ticket);
  const thumbnailUrl = cleanString(ticket?.thumbnailUrl || images[0]);
  const img = cleanString(images[0] || thumbnailUrl);

  return {
    ticketId,
    ticketNumber: ticketId,
    ticketid: ticketId,
    createdAt: getTicketCreatedAt(ticket),
    datetime: cleanString(ticket?.datetime),
    date: cleanString(ticket?.date),
    time: cleanString(ticket?.time),
    plate,
    carplate: plate,
    plateNormalized,
    make: carbrand,
    model: carmodel,
    carbrand,
    carmodel,
    unit: cleanString(ticket?.unit || ticket?.viewstationnement || ticket?.locationID),
    location: cleanString(ticket?.location || address || contract),
    contract,
    address,
    thumbnailUrl,
    imagePath: cleanString(ticket?.imagePath),
    img,
    images,
  };
};

export const normalizePlateIndexEntry = (entry, fallbackId = '') => (
  buildPlateIndexEntry(entry, fallbackId)
);

export const sortPlateIndexEntriesNewestFirst = entries => [...entries].sort((left, right) => (
  getTicketCreatedAt(right) - getTicketCreatedAt(left)
  || getTicketId(right).localeCompare(getTicketId(left))
));
